import {
    get,
    post
} from '../utils/request';
// 教练员注册
export const addCoach = params => post('/coach/add', params);
// 获取教练员列表
export const getCoachList = params => get('/coach/list', params);
// 获取教练员详情
export const getCoachDetail = params => get('/coach/detail', params);
// 修改
export const updateCoach = params => post('/coach/update', params);
// 分会审核
export const coachSocietyAudit = params => post('/coach/societyAudit', params);

/**
 * 运动员统计列表
 * @param {refereeRank} 裁判员等级(国际级、国家级、荣誉级、一级、二级)
 */
export const getCoachCountList = params => get('/statistics/getCoachCountList', params);
// 删除教练员
export const deleteCoach = params => post('/coach/delete',params); 